export const BASE_EXPENSE = {
  expenditure_type: undefined,
  monthly_amount: {
    amount: undefined,
    currency: 'GBP',
  },
};

export const EXPENSE_BUTTON_LABEL = 'Add new source of expense';

export const EXPENSE_PROPS = {
  name: 'monthly_amount.amount',
  type: 'price',
  icon: 'pound',
  iconVariant: 'dark',
  symbol: '',
  label: 'Monthly amount',
  placeholder: 'The monthly expenditure for this source',
  validation: {
    required: {
      value: true,
      message: 'You must provide the expenditure amount',
    },
    min: { value: 1, message: 'Amount must be great than £0.01' },
  },
};

export const EXPENSE_OPTIONS = [
  { name: 'Credit Card', value: 'credit_card' },
  { name: 'Clothes', value: 'clothes' },
  { name: 'Council Tax And Bills', value: 'council_tax_and_bills' },
  { name: 'Child Support Agency', value: 'child_support_agency' },
  { name: 'Healthcare', value: 'healthcare' },
  { name: 'Holidays', value: 'holidays' },
];

export const EXPENSE_SELECT_PROPS = {
  placeholder: 'Select...',
  label: 'Expense Type',
  options: EXPENSE_OPTIONS,
  validation: {
    required: {
      value: true,
      message: 'You must select an expense type',
    },
  },
};
